import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import CheckIcon from '../../assets/svgs/CheckIcon';
import ChevronIcon from '../../assets/svgs/ChevronIcon';

import { TypesSelectStyle } from './TypesSelectStyle';

const TypesSelect = ({
  types,
  selected,
  parent,
  placeholder,
  disabled,
  handleSelect,
}) => {
  const [show, setShow] = useState(false);

  const isSubtype = useMemo(() => !!parent, [parent]);

  useEffect(() => {
    if (selected) {
      setShow(false);
    }
  }, [parent?.id, selected]);

  return (
    <TypesSelectStyle
      className={types?.length && !disabled && show ? 'show' : null}
    >
      <button
        type="button"
        className="show-hide-list"
        disabled={disabled}
        onClick={() => setShow(!show)}
      >
        {!show &&
        selected &&
        selected?.color?.length &&
        selected?.name?.length ? (
          <div className="show-hide-selected">
            <div
              className="selected-box"
              style={{
                backgroundColor: selected?.color,
                borderColor: selected?.color,
              }}
            >
              <CheckIcon />
            </div>
            <div className="selected-name">
              {selected?.id === parent?.id ? 'Any' : selected?.name}
            </div>
          </div>
        ) : (
          <div className="show-hide-unselected">
            {placeholder || 'Select Type'}
          </div>
        )}
        <span className="icon">
          <ChevronIcon />
        </span>
      </button>
      {types?.length ? (
        <div className="types-list-container">
          {isSubtype ? (
            <button
              className={`type-option type-any${
                selected?.id === parent?.id ? ' selected' : ''
              }`}
              type="button"
              onClick={() =>
                handleSelect(selected?.id !== parent?.id ? parent : null)
              }
            >
              <div
                className="option-box"
                style={{
                  backgroundColor:
                    selected?.id === parent?.id ? parent?.color : 'transparent',
                  borderColor: parent?.color,
                }}
              >
                <CheckIcon />
              </div>
              <div className="option-name">Any</div>
            </button>
          ) : null}
          {types?.map((type) => {
            if (type?.id && type?.name?.length && type?.color?.length) {
              return (
                <button
                  key={type?.id}
                  className={`type-option${
                    selected?.id === type?.id ? ' selected' : ''
                  }`}
                  type="button"
                  onClick={() =>
                    handleSelect(selected?.id !== type?.id ? type : null)
                  }
                >
                  <div
                    className="option-box"
                    style={{
                      backgroundColor:
                        selected?.id === type?.id ? type?.color : 'transparent',
                      borderColor: type?.color,
                    }}
                  >
                    <CheckIcon />
                  </div>
                  <div className="option-name">{type?.name}</div>
                  {!isSubtype && type?.subtypes?.length ? (
                    <div className="option-subtypes-count">
                      {`${type?.subtypes?.length} Types`}
                    </div>
                  ) : null}
                </button>
              );
            }

            return null;
          })}
        </div>
      ) : null}
    </TypesSelectStyle>
  );
};

TypesSelect.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      color: PropTypes.string,
      subtypes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          name: PropTypes.string,
          color: PropTypes.string,
        })
      ),
    })
  ),
  selected: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    color: PropTypes.string,
    subtypes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        color: PropTypes.string,
      })
    ),
  }),
  parent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    color: PropTypes.string,
    subtypes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        color: PropTypes.string,
      })
    ),
  }),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  handleSelect: PropTypes.func.isRequired,
};

TypesSelect.defaultProps = {
  types: [],
  selected: null,
  parent: null,
  placeholder: '',
  disabled: false,
};

export default TypesSelect;
